import { render, staticRenderFns } from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=template&id=0b702acf&scoped=true&"
import script from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=style&index=0&id=0b702acf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b702acf",
  null
  
)

export default component.exports